/* eslint jsx-a11y/aria-role: 0 */
import React, { Component } from 'react';
import './style.css';

const pluralize = require('pluralize');

/*
  props:
    sizes
    sizeIndex
    onChange(sizeIndex)
*/
class SizePicker extends Component {
  getButtonStyle = () => {
    const color = `#${this.props.secondaryColor}`;

    return { color, borderColor: color };
  }

  handleNext = () => {
    if (this.props.sizeIndex < this.props.sizes.length - 1) {
      this.props.onChange(this.props.sizeIndex + 1);
      this.props.setIndex(this.props.sizeIndex + 1);
    }
  }

  handlePrev = () => {
    if (this.props.sizeIndex > 0) {
      this.props.onChange(this.props.sizeIndex - 1);
      this.props.setIndex(this.props.sizeIndex - 1);
    }
  }

  isNext = () => this.props.sizeIndex < this.props.sizes.length - 1

  isPrev = () => this.props.sizeIndex > 0

  render() {
    const { weight } = this.props.sizes[this.props.sizeIndex];
    const gramms = pluralize('gram', weight);
    return (
      <div className="quantity-picker">
        <div className="operator-wrapper">
          <div
            style={{ ...this.getButtonStyle(), ...{ opacity: (this.isPrev() ? '1' : '0.4') } }}
            onClick={this.handlePrev}
            className="operator"
            role="decreaseAmt"
          >
&minus;
          </div>
          <div className="amt">
            <div className="qnt">
              {' '}
              {weight}
            </div>
&nbsp;&nbsp;
            {' '}
            {gramms}
          </div>
          <div
            style={{ ...this.getButtonStyle(), ...{ opacity: (this.isNext() ? '1' : '0.4') } }}
            onClick={this.handleNext}
            className="operator"
            role="increaseAmt"
          >
+
          </div>
        </div>
      </div>
    );
  }
}

export default SizePicker;



// WEBPACK FOOTER //
// ./src/components/SizePicker/SizePicker.jsx